import { ROUTES } from '@/common/constants/routes';
import { router, useSegments } from 'expo-router';

export function dismissFlow() {
  if (router.canDismiss()) {
    return router.dismiss();
  }
  if (router.canGoBack()) {
    return router.back();
  }

  return router.replace(ROUTES.ROOT);
}

export function useIsInFlowLayout() {
  const segments = useSegments();
  return segments.some((segment) => segment === '(flow)');
}
